import React, { useState, useContext, useEffect } from 'react'
import { Box, Button, IconButton, Tooltip } from '@mui/material'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import { mapData } from '@/product/common/components'
import { useFormik } from 'formik'
import { useTranslation } from 'react-i18next'
import authContext from '@/product/context/auth/authContext'
import StripeCardContext from '@/product/context/stripe/card/cardContext'
import StripeCustomerContext from '@/product/context/stripe/customer/customerContext'
import UserContext from '@/product/context/user/userContext'
import CardDetails from './CardManage'
// import CardDetails from '@/custom/components/organisms/CardDetails'
import Layout from '@/product/components/templates/Layout'

const UserCards = (props) => {
    //user's cards view page
    const [cards, setCards] = useState([])
    const { user, loadUser, isAuthenticated } = useContext(authContext)
    const {
        updateProfile,
        updatePreference,
        responseStatus: responseStatusUser,
    } = useContext(UserContext)

    const {
        customer_details,
        createStripeCustomer,
        getStripeCustomer,
        responseStatus: customerResponseStatus,
    } = useContext(StripeCustomerContext)
    const {
        get_all_card_details,
        getAllStripeCards,
        responseStatus: responseStatusCard,
        clearResponse: clearResponseCard,
    } = useContext(StripeCardContext)

    const [manageCard, setManageCard] = useState({
        popup: false,
        status: 'new',
        data: null,
    })
    const toggleFullScreenCardPopup = (popup, status, data) => {
        setManageCard({ popup, status, data })
    }
    //get stripe card
    const getStripeCards = () => {
        // console.log('user!@#', user)
        if (user && user.stripe_id) {
            getAllStripeCards({
                account_id: process.env.REACT_APP_STRIPE_ACCOUNT,
                customer_id: user.stripe_id,
                object: 'card',
            })
        }
        toggleFullScreenCardPopup(false, 'new', null)
    }
    const { t } = useTranslation()
    //const [addCard, setAddCard] = useState(false)
    const formik = useFormik({
        initialValues: {
            email: '',
            password: '',
            confirm_password: '',
        },
    })
    /*const addCardData = [
        {
            label: t('name'),
            name: 'name',
            type: 'email',
            placeholder: t('enter_card_holder_name'),
            class: 'col-12',
            autoFocus: true,
            formik: formik,
        },
        {
            label: t('card_number'),
            name: 'card_number',
            type: 'number',
            placeholder: t('enter_card_number'),
            class: 'col-12',
            formik: formik,
        },
        {
            label: t('name'),
            name: 'name',
            type: 'email',
            placeholder: t('enter_card_holder_name'),
            class: 'col-12',
            autoFocus: true,
            formik: formik,
        },
        {
            label: 'CVV',
            name: 'cvv',
            type: 'text',
            placeholder: t('enter') + ' CVV',
            class: 'col-12',
            formik: formik,
        },
        {
            label: t('expiry_date'),
            name: 'expiry_date',
            type: 'date',
            placeholder: t('date_of_card_expiration'),
            class: 'col-12',
            formik: formik,
        },
    ]*/
    //create stripe customer
    useEffect(() => {
        if (user && user.id && !user.stripe_id) {
            // console.log('user@#', user)
            createStripeCustomer(
                {
                    account_id: process.env.REACT_APP_STRIPE_ACCOUNT,
                    description: 'TEST CUSTOMER',
                    email: user.email,
                    name: user.first_name + ' ' + user.last_name,
                },
                true
            )
        } else if (user && user.id && user.stripe_id) {
            // console.log('%^&stripe', user.stripe_id)
            getStripeCards()
        }
    }, [user])
    useEffect(() => {
        if (
            customerResponseStatus &&
            customerResponseStatus.from == 'create' &&
            customerResponseStatus.status == 'success'
        ) {
            updateProfile({ stripe_id: customerResponseStatus.data.id }, true)
        }
    }, [customerResponseStatus])

    useEffect(() => {
        if (responseStatusUser) {
            if (
                responseStatusUser.from === 'updateProfile' ||
                responseStatusUser.from === 'updatePreference'
            ) {
                if (responseStatusUser.status === 'success') {
                    loadUser()
                }
            }
        }
    }, [responseStatusUser])
    useEffect(() => {
        if (responseStatusCard) {
            getStripeCards()
        }
    }, [responseStatusCard])
    useEffect(() => {
        if (get_all_card_details) {
            // console.log('!@#get_all_card_details', get_all_card_details)
            setCards(get_all_card_details.records)
        }
        return () => {
            setCards([])
        }
    }, [get_all_card_details])
    useEffect(() => {
        if (!user) {
            //loadUser()
        }
        // console.log('user', user)
        //loadUser()
    }, [])
    return (
        <Layout>
            <>
                <div className="dashboardInner mySavedCards">
                    <div
                        className="emptySavedCard"
                        onClick={() =>
                            toggleFullScreenCardPopup(true, 'new', null)
                        }
                    >
                        <img
                            src="/assets/images/cards.png"
                            alt="bank"
                            className="mt-1 mb-1"
                        />
                        <h6>ADD A NEW CARD</h6>
                        <img
                            src="/assets/images/ccard.png"
                            alt="bank"
                            className="mt-1 mb-1"
                        />
                    </div>
                    {cards.length > 0
                        ? cards.map((card) => {
                              return (
                                  // eslint-disable-next-line react/jsx-key
                                  <div className="saved-card">
                                      <div className="filledSavedCard">
                                          <div className="row mt-2">
                                              <div className="col-6 text-left">
                                                  <img
                                                      src="/assets/images/sim.png"
                                                      alt="bank"
                                                  />
                                              </div>
                                              {/* <div className="sc-primary-label">Primary Card</div> */}
                                          </div>
                                          <div className="card-num">
                                              <span>****</span>
                                              <span>****</span>
                                              <span>****</span>
                                              <span>{card.last4}</span>
                                          </div>
                                          {/* {console.log('!@#card', card)} */}
                                          <div className="clearfix">
                                              <div className="float-left">
                                                  <div className="fs-12">
                                                      {card.name}
                                                  </div>
                                              </div>
                                              <div className="float-right">
                                                  <div className="fs-12">
                                                      {card.exp_month} /{' '}
                                                      {card.exp_year
                                                          .toString()
                                                          .slice(-2)}
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                      <div className="sc-btns-wrap d-flex align-items-center justify-content-between">
                                          <IconButton
                                              className="edtBtn"
                                              onClick={() =>
                                                  toggleFullScreenCardPopup(
                                                      true,
                                                      'update',
                                                      card
                                                  )
                                              }
                                          >
                                              <span className="material-icons">
                                                  edit
                                              </span>
                                          </IconButton>
                                          {cards.length > 1 && (
                                              <IconButton
                                                  className="dltBtn"
                                                  onClick={() =>
                                                      toggleFullScreenCardPopup(
                                                          true,
                                                          'delete',
                                                          card
                                                      )
                                                  }
                                              >
                                                  <span className="material-icons">
                                                      delete
                                                  </span>
                                              </IconButton>
                                          )}
                                      </div>
                                  </div>
                              )
                          })
                        : ''}
                    <CardDetails
                        allCards={cards}
                        data={manageCard}
                        function={toggleFullScreenCardPopup}
                    />
                    {/*<Popup
                        open={addCard}
                        size="md"
                        handleClose={() => setAddCard(false)}
                        modaltitle={t('add_a_new_card')}
                    >
                        <form onSubmit={formik.handleSubmit}>
                            <div className="row">{Object.values(mapData(addCardData))}</div>
                            <div className="row">
                                <div className="col-12 text-center">
                                    <PrimaryButton label={t('save')} />
                                </div>
                            </div>
                        </form>
                    </Popup>*/}
                </div>
            </>
        </Layout>
    )
}

export default UserCards
